// App imports.
import { IIndexYear, IGranteeRegionIndexYear, IIndexResults, IGranteeHouseholdsServed } from "./utility";
import * as utility from "./utility";
import * as worker from "../baseWorker";
import { IGranteePortalSearchParams, IGranteePortalResults } from "../baseWorker";
import { RadioOptionsEnum } from "../BaseComponents/RadioYesNoAll"
import { IRegion } from "../baseWorker";


export enum AppPagesEnum {
  IntroPage1 = 0,
  IntroPage2 = 1,
  IntroPage3 = 2,
  IntroPage4 = 3,
  SelectionScreen = 4,
  BenefitTargeting1 = 5,
  BenefitTargeting2 = 6,
  BenefitTargeting3 = 7,
  BenefitTargetingComp1 = 8,
  BenefitTargetingComp2 = 9,
  BenefitTargetingComp3 = 10,
  BenefitTargetingComp4 = 11,
  BenefitTargetingComp5 = 12,
}

export enum TargetingTrendEnum {
  Improved = "improved",
  Deteriorated = "deteriorated",
  Maintained = "stayed the same"
}

export class IndexYear implements IIndexYear {
  Year: number;
  BurdenReductionIndex: number;
  BenefitTargetingIndex: number;
  NatlAvgBurdenReductionIndex: number;
  NatlAvgBenefitTargetingIndex: number;
  HouseholdsAssisted: number;
  HouseholdsCompleteData: number;
  constructor(year: number
    , benefitTargetingIndex: number
    , burdenReductionIndex: number
    , averageBenefitTargetingIndex: number
    , averageBurdenReductionIndex: number
    , householdsAssisted: number
    , householdsCompleteData: number) {
    this.Year = year;
    this.BurdenReductionIndex = burdenReductionIndex;
    this.BenefitTargetingIndex = benefitTargetingIndex;
    this.NatlAvgBurdenReductionIndex = averageBurdenReductionIndex;
    this.NatlAvgBenefitTargetingIndex = averageBenefitTargetingIndex;
    this.HouseholdsAssisted = householdsAssisted;
    this.HouseholdsCompleteData = householdsCompleteData;
  }
  get IndexRepresentsPctString(): string {
    if (+this.HouseholdsAssisted === 0) {
      return "N/A";
    }
    else {
      return `${((+this.HouseholdsCompleteData / +this.HouseholdsAssisted) * 100).toFixed()}%`;
    }
    
  }
  get BenefitTargetingPctDiffString(): string {
    //deal with index value > 100
    if (this.BenefitTargetingIndex > 100) {
      return `received a ${(+this.BenefitTargetingIndex - 100).toFixed()}% larger benefit than the average LIHEAP recipient household in your state.`;
    }
    //deal with index value < 100
    else if (this.BenefitTargetingIndex < 100) {
      return `received a ${(+100 - this.BenefitTargetingIndex).toFixed()}% smaller  benefit than the average LIHEAP recipient household.`;
    }
    else if (this.BenefitTargetingIndex == 100) {
      return 'received the same benefit as the average LIHEAP recipient household.';
    }
  }
  get BurdenReductionPctDiffString(): string {
    //deal with index value > 100
    if (this.BurdenReductionIndex > 100) {
      return `had ${(+this.BurdenReductionIndex - 100).toFixed()}% more of their bill paid by LIHEAP than the average LIHEAP recipient household in your state.`;
    }
    //deal with index value < 100
    else if (this.BurdenReductionIndex < 100) {
      let percentDifference = (100 - (+this.BurdenReductionIndex)).toFixed();

      return `had ${percentDifference}% less of their bill paid by LIHEAP than the average LIHEAP recipient household in your state.`;
    }
    else if (this.BurdenReductionIndex == 100) {
      return 'had the same percentage of their bill paid as the average LIHEAP recipient household in your state.';
    }
  }
  get AverageBenefitTargetingPctDiffString(): string {
    //deal with index value > 100
    if (this.NatlAvgBenefitTargetingIndex > 100) {
      return ` received a ${(+this.NatlAvgBenefitTargetingIndex - 100).toFixed()}% larger benefit than the average LIHEAP recipient household.`;
    }
    //deal with index value < 100
    else if (this.NatlAvgBenefitTargetingIndex < 100) {
      return ` received a ${(+this.NatlAvgBenefitTargetingIndex - 100).toFixed()}% smaller benefit than the average LIHEAP recipient household.`;
    }
    else if (this.NatlAvgBenefitTargetingIndex == 100) {
      return ' received the same benefit as average households.';
    }
  }
  get AverageBurdenReductionPctDiffString(): string {
    //deal with index value > 100
    if (this.NatlAvgBurdenReductionIndex > 100) {
      return ` had ${(+this.NatlAvgBurdenReductionIndex - 100).toFixed()}% more of their bill paid by LIHEAP than the average LIHEAP recipient household.`;
    }
    //deal with index value < 100
    else if (this.NatlAvgBurdenReductionIndex < 100) {
      return ` had ${(100 - this.NatlAvgBurdenReductionIndex).toFixed()}% less of their bill paid by LIHEAP than the average LIHEAP recipient household.`;
    }
    else if (this.NatlAvgBurdenReductionIndex == 100) {
      return ' the same percentage of their bill paid as average LIHEAP recipient households.';
    }
  }
  get BenefitTargetingNationalCompString(): string {
    //deal with index value < average
    if (this.NatlAvgBenefitTargetingIndex > this.BenefitTargetingIndex) {
      return `In FY ${this.Year}, your state was below the average for all states in terms of targeting benefits to the households with the highest burdens.`;
    }
    //deal with index value > average
    else if (this.NatlAvgBenefitTargetingIndex < this.BenefitTargetingIndex) {
      return `In FY ${this.Year}, your state was above the average for all states in terms of targeting benefits to the households with the highest burdens.`;
    }
    else if (this.NatlAvgBenefitTargetingIndex == this.BenefitTargetingIndex) {
      return `In FY ${this.Year}, your state was about the same as the average for all states in terms of targeting benefits to the households with the highest burdens. `;
    }
  }
  get BurdenReductionNationalCompString(): string {
    //deal with index value < average
    if (this.NatlAvgBurdenReductionIndex > this.BurdenReductionIndex) {
      return `In FY ${this.Year}, your state was below the average for all states in terms of targeting benefits to pay a greater percentage of the bill for households with the highest burdens.`;
    }
    //deal with index value > average
    else if (this.NatlAvgBurdenReductionIndex < this.BurdenReductionIndex) {
      return `In FY ${this.Year}, your state was above the average for all states in terms of targeting benefits to pay a greater percentage of the bill for households with the highest burdens.`;
    }
    else if (this.NatlAvgBurdenReductionIndex == this.BurdenReductionIndex) {
      return `In FY ${this.Year}, your state was about the same as the average for all states in terms of targeting benefits to pay a greater percentage of the bill for households with the highest burdens.`;
    }
  }
}

export class GranteeRegionIndexYear implements IGranteeRegionIndexYear {
  Year: number;
  GranteeName: string;
  BurdenReductionIndex: number;
  BenefitTargetingIndex: number;
  RegionName: string;
  RegAvgBurdenReductionIndex: number;
  RegAvgBenefitTargetingIndex: number;
  HouseholdsAssisted: number;
  HouseholdsCompleteData: number;
  constructor(year: number
    , granteeName: string
    , benefitTargetingIndex: number
    , burdenReductionIndex: number
    , regionName: string
    , regAvgBenefitTargetingIndex: number
    , regAvgBurdenReductionIndex: number
    , householdsAssisted: number
    , householdsCompleteData: number) {
    this.Year = year;
    this.GranteeName = granteeName;
    this.BurdenReductionIndex = burdenReductionIndex;
    this.BenefitTargetingIndex = benefitTargetingIndex;
    this.RegionName = regionName;
    this.RegAvgBurdenReductionIndex = regAvgBurdenReductionIndex;
    this.RegAvgBenefitTargetingIndex = regAvgBenefitTargetingIndex;
    this.HouseholdsAssisted = householdsAssisted;
    this.HouseholdsCompleteData = householdsCompleteData;
  }
  get IndexRepresentsPctString(): string {
    if (+this.HouseholdsAssisted === 0) {
      return "N/A";
    }
    else {
      return `${((+this.HouseholdsCompleteData / +this.HouseholdsAssisted) * 100).toFixed()}%`;
    }
    
  }
  get BenefitTargetingRegionalCompString(): string {
    //deal with index value > 1
    if (this.RegAvgBenefitTargetingIndex > this.BenefitTargetingIndex) {
      return `In FY ${this.Year}, your state was below the average for states in your OCS region in terms of targeting benefits to households with the highest burdens.`;
    }
    //deal with index value < 1
    else if (this.RegAvgBenefitTargetingIndex < this.BenefitTargetingIndex) {
      return `In FY ${this.Year}, your state was above the average for states in your OCS region in terms of targeting benefits to households with the highest burdens.`;
    }
    else if (this.RegAvgBenefitTargetingIndex == this.BenefitTargetingIndex) {
      return `In FY ${this.Year}, your state was about the same as the average for states in your OCS region in terms of targeting benefits to households with the highest burdens.`;
    }
  }
  get BurdenReductionRegionalCompString(): string {
    //deal with index value > 1
    if (this.RegAvgBurdenReductionIndex > this.BurdenReductionIndex) {
      return `In ${this.Year}, your state was below the average for states in your OCS region in terms of targeting benefits to pay a greater percentage of the bill for households with the highest burdens.`;
    }
    //deal with index value < 1
    else if (this.RegAvgBurdenReductionIndex < this.BurdenReductionIndex) {
      return `In ${this.Year}, your state was above the average for states in your OCS region in terms of targeting benefits to pay a greater percentage of the bill for households with the highest burdens.`;
    }
    else if (this.RegAvgBurdenReductionIndex == this.BurdenReductionIndex) {
      return `In ${this.Year}, your state was about the same as the average for states in your OCS region in terms of targeting benefits to pay a greater percentage of the bill for households with the highest burdens.`;
    }
  }
}

export class IndexHistory implements IIndexResults {
  IndexCode: string;
  IndexYears: IndexYear[];
  RegionIndices: GranteeRegionIndexYear[];
  EarliestYear: IndexYear;
  LatestYear: IndexYear;
  GranteeName: string;
  GranteeAbbreviation: string;
  constructor(indexCode: string
    , indexYears: IndexYear[]
    , regionIndices: GranteeRegionIndexYear[]
    , granteeName: string
    , granteeAbbreviation: string) {
    this.IndexCode = indexCode;
    this.IndexYears = indexYears;
    this.GranteeName = granteeName;
    this.GranteeAbbreviation = granteeAbbreviation;
    this.RegionIndices = regionIndices;
    //set the latest year property for various display uses
    let sortedYears: IndexYear[] = this.IndexYears.sort((a, b) => a.Year - b.Year);
    this.EarliestYear = sortedYears[0];
    this.LatestYear = sortedYears[sortedYears.length - 1];
  }
  get TargetingTrendValue(): string {
    return (
      this.LatestYear.BenefitTargetingIndex > this.EarliestYear.BenefitTargetingIndex ?
        TargetingTrendEnum.Improved :
        this.LatestYear.BenefitTargetingIndex == this.EarliestYear.BenefitTargetingIndex ?
          TargetingTrendEnum.Maintained :
          TargetingTrendEnum.Deteriorated
    );
  }
  get BurdenReductionTrendValue(): string {
    if (this.LatestYear.BurdenReductionIndex > this.EarliestYear.BurdenReductionIndex) {
      return " done a better job when it comes to paying a greater percentage of the bill for highest burden households.";
    }
    else if (this.LatestYear.BurdenReductionIndex < this.EarliestYear.BurdenReductionIndex) {
      return " done a worse job when it comes to paying a greater percentage of the bill for highest burden households.";
    }
    else {
      return " stayed about the same when it comes to paying a greater percentage of the bill for highest burden households.";
    }
  }
  get SelectedIndexString(): string {
    if (this.IndexCode === utility.IndexCodeEnum.BurdenReductionIndex) {
      return "Burden Reduction Targeting";
    }
    else if (this.IndexCode === utility.IndexCodeEnum.TargetingIndex) {
      return "Benefit Targeting";
    }
    else {
      return "";
    }
  }
  get SelectedIndexTrendValue(): string {
    if (this.IndexCode === utility.IndexCodeEnum.BurdenReductionIndex) {
      return this.BurdenReductionTrendValue;
    }
    else if (this.IndexCode === utility.IndexCodeEnum.TargetingIndex) {
      return this.TargetingTrendValue;
    }
    else {
      return '';
    }
  }
  get LatestYearSelectedIndexPctDiffString(): string {
    // Add null check for LatestYear to prevent TypeError
    if (!this.LatestYear) {
      return '';
    }

    if (this.IndexCode === utility.IndexCodeEnum.BurdenReductionIndex) {
      return this.LatestYear.BurdenReductionPctDiffString || '';
    }
    else if (this.IndexCode === utility.IndexCodeEnum.TargetingIndex) {
      return this.LatestYear.BenefitTargetingPctDiffString || '';
    }
    else {
      return '';
    }
  }
  get LatestYearSelectedIndex(): number {
    // Add null check for LatestYear to prevent TypeError
    if (!this.LatestYear) {
      return 0;
    }

    if (this.IndexCode === utility.IndexCodeEnum.BurdenReductionIndex) {
      return this.LatestYear.BurdenReductionIndex || 0;
    }
    else if (this.IndexCode === utility.IndexCodeEnum.TargetingIndex) {
      return this.LatestYear.BenefitTargetingIndex || 0;
    }
    else {
      return 0;
    }
  }
  get LatestYearNatlAvgIndex(): number {
    // Add null check for LatestYear to prevent TypeError
    if (!this.LatestYear) {
      return 0;
    }

    if (this.IndexCode === utility.IndexCodeEnum.BurdenReductionIndex) {
      return this.LatestYear.NatlAvgBurdenReductionIndex || 0;
    }
    else if (this.IndexCode === utility.IndexCodeEnum.TargetingIndex) {
      return this.LatestYear.NatlAvgBenefitTargetingIndex || 0;
    }
    else {
      return 0;
    }
  }
  get LatestYearAvgPctDiffString(): string {
    // Add null check for LatestYear to prevent TypeError
    if (!this.LatestYear) {
      return '';
    }

    if (this.IndexCode === utility.IndexCodeEnum.BurdenReductionIndex) {
      return this.LatestYear.AverageBurdenReductionPctDiffString || '';
    }
    else if (this.IndexCode === utility.IndexCodeEnum.TargetingIndex) {
      return this.LatestYear.AverageBenefitTargetingPctDiffString || '';
    }
    else {
      return '';
    }
  }
  get LatestYearNationalCompString(): string {
    // Add null check for LatestYear to prevent TypeError
    if (!this.LatestYear) {
      return '';
    }

    if (this.IndexCode === utility.IndexCodeEnum.BurdenReductionIndex) {
      return this.LatestYear.BurdenReductionNationalCompString || '';
    }
    else if (this.IndexCode === utility.IndexCodeEnum.TargetingIndex) {
      return this.LatestYear.BenefitTargetingNationalCompString || '';
    }
    else {
      return "";
    }
  }
}

/**
 * This function must be called once and only once from BaseLayout.
 */
export function createState(inParentComponent) {
  return {
    //----------------------------------------------------------------------------------------------
    // General Variables
    //----------------------------------------------------------------------------------------------
    ErrorMessage: '',
    CreateAssessmentErrorMessage: '',
    ShowSpinner: false,
    UserInfo: {
      granteeId: -1,
      viewAll: false,
      loggedIn: false
    },
    CurrentAppPage: AppPagesEnum.IntroPage1,
    Grantees: [],
    Regions: [],
    SelectedGranteeId: null,
    SelectedGranteeArray: [],
    SelectedRegionId: null,
    ShowNextStepDisabled: false,
    SelectedIndexCode: utility.IndexCodeEnum.NotSet,
    SelectedIndexHistory: null,
    CategoricalEligibility: RadioOptionsEnum.All,
    HasCoolingProgram: RadioOptionsEnum.All,
    RunsAssurance16: RadioOptionsEnum.All,
    IncomeThreshold: -99,
    ProgramFundingLevel: RadioOptionsEnum.All,
    TypeOfITSystem: RadioOptionsEnum.All,
    OrgPerformingIntake: RadioOptionsEnum.All,
    CrisisPeriod: RadioOptionsEnum.All,
    PercentageForWeatherization: -99,
    EnergyAssistProgram: RadioOptionsEnum.All,
    ClimateZone: RadioOptionsEnum.All,
    FuelTypes: RadioOptionsEnum.All,
    GranteePortalResults: null,
    GranteeHouseholdsServed: [],
    selectedIndexValOperator: 'ALL',
    enteredIndexVal: 100,
    enteredIndexValUpperBound: 100,

    includeBenefitLevels: false,
    includeBenefitMatrix: false,
    includeContact: false,
    includeCriteriaForVarying: false,
    includeGranteeProfiles: false,
    includeHousing: false,
    includeNominalBenefits: false,
    includeOutreach: false,
    includeWzDescription: false,
    includeIncomeThreshold: false,
    includeIntakeOrganizationType: false,
    includePercentageWeatherization: false,
    includeCrisis: false,
    includeCategoricalEligibility: false,
    includeCooling: false,
    includeAssurance16: false,

    //----------------------------------------------------------------------------------------------


    //----------------------------------------------------------------------------------------------
    // Control methods and variables
    //----------------------------------------------------------------------------------------------
    setGrantees: function (inGrantees: worker.IGrantee[]): void {
      this.setState({
        Grantees: inGrantees,
      });
    }.bind(inParentComponent),
    SelectStateFieldChangeHandler: function (inEvent: any): void {
      let newGranteeId = inEvent.target.value;
      //set state object
      this.setState({
        ErrorMessage: '',
        SelectedGranteeId: newGranteeId,
        SelectedGranteeArray: [newGranteeId]
      });
    }.bind(inParentComponent),
    lboIndexCodeFieldChangeHandler: function (inEvent: any): void {
      let newIndexCode = inEvent.target.value;
      let newShowNextStepDisabled = this.state.ShowNextStepDisabled;
      if (newIndexCode !== utility.IndexCodeEnum.NotSet) {
        newShowNextStepDisabled = false;
      }
      //set state object
      this.setState({
        ErrorMessage: '',
        SelectedIndexCode: newIndexCode,
        ShowNextStepDisabled: newShowNextStepDisabled,
      });
    }.bind(inParentComponent),
    showNextStep: async function (): Promise<void> {
      if (this.state.CurrentAppPage < AppPagesEnum.BenefitTargetingComp5) {
        // React 18: Immediate UI update for spinner
        this.setState({ ShowSpinner: true });
        
        let errorMessage: string = '';
        let newAppPage = this.state.CurrentAppPage + 1;
        let newShowNextStepDisabled: boolean = false;
        let regions: IRegion[] = Object.assign([], this.state.Regions);
        let selectedGranteeArray = Object.assign([], this.state.SelectedGranteeArray);

        //if we are going to the select screen and haven't picked
        //and index type to show, disable next button
        if (newAppPage == AppPagesEnum.SelectionScreen
          && this.state.SelectedIndexCode == utility.IndexCodeEnum.NotSet) {
          newShowNextStepDisabled = true;
        }

        //if we are going to benefit targeting screen
        //or burden reduction screen
        //and we don't have index history
        let myHistoryObject: IndexHistory = Object.assign(new IndexHistory('', [], [], '', ''), this.state.SelectedIndexHistory);
        let searchPortalResults: IGranteePortalResults = Object.assign({
          columnNames: [],
          reportData: []
        }, this.state.GranteePortalResults);
        let granteeHouseholdsServed: IGranteeHouseholdsServed[] = [];
        if (newAppPage == AppPagesEnum.BenefitTargeting1) {
          try {
            //lookup from database
            const utilityWorker: utility.PerformanceDataWorker = new utility.PerformanceDataWorker();
            let indexResults: IIndexResults = await utilityWorker.getGranteeIndexResults(this.state.SelectedGranteeId);

            //get years for current grantee and national average
            let indexYearsArray: IndexYear[] = [];
            indexResults.IndexYears.map(yr =>
              indexYearsArray.push(
                new IndexYear(
                  yr.Year
                  , Math.round(yr.BenefitTargetingIndex)
                  , Math.round(yr.BurdenReductionIndex)
                  , Math.round(yr.NatlAvgBenefitTargetingIndex)
                  , Math.round(yr.NatlAvgBurdenReductionIndex)
                  , Math.round(yr.HouseholdsAssisted)
                  , Math.round(yr.HouseholdsCompleteData)
                )
              )
            );

            //get states in grantee's region and regional average
            let regionIndicesArray: GranteeRegionIndexYear[] = [];
            indexResults.RegionIndices.map(yr =>
              regionIndicesArray.push(
                new GranteeRegionIndexYear(
                  yr.Year
                  , yr.GranteeName
                  , Math.round(yr.BenefitTargetingIndex)
                  , Math.round(yr.BurdenReductionIndex)
                  , yr.RegionName
                  , Math.round(yr.RegAvgBenefitTargetingIndex)
                  , Math.round(yr.RegAvgBurdenReductionIndex)
                  , Math.round(yr.HouseholdsAssisted)
                  , Math.round(yr.HouseholdsCompleteData)
                )
              )
            );

            //build the this.state.SelectedIndexHistory object
            myHistoryObject = new IndexHistory(this.state.SelectedIndexCode
              , indexYearsArray
              , regionIndicesArray
              , this.state.getGranteeName(this.state.SelectedGranteeId)
              , this.state.getGranteeAbbreviation(this.state.SelectedGranteeId)
            );
          }
          catch (err) {
            errorMessage = err.response.data.message;
          }
        }
        //if we are getting states to compare to
        else if (newAppPage == AppPagesEnum.BenefitTargetingComp4) {
          //get regions
          const myWorker: worker.baseWorker = new worker.baseWorker();
          try {
            //we get an array of regions
            regions = await myWorker.getRegions();
          }
          catch (err) {
            errorMessage = err.response.data.message;
          }
          //if user has a selected region, then set selected states
          if (this.state.SelectedRegionId != null) {
            selectedGranteeArray = this.state.Grantees
              .filter(g =>
                g.regionId == +this.state.SelectedRegionId
              )
              .map(g =>
                g.granteeId
              );
          }
        }
        //if we are getting states to compare to
        else if (newAppPage == AppPagesEnum.BenefitTargetingComp5) {

          try {
            //create a grantee search portal search object
            let searchParams: IGranteePortalSearchParams = {
              //determine which index to include
              includeBenefitTargetingIndex: (this.state.SelectedIndexCode == utility.IndexCodeEnum.TargetingIndex),
              includeBurdenReductionIndex: (this.state.SelectedIndexCode == utility.IndexCodeEnum.BurdenReductionIndex),

              includeContact: this.state.includeContact,
              includeGranteeProfiles: this.state.includeGranteeProfiles,

              includeCooling: this.state.includeCooling,
              includeWzDescription: this.state.includeWzDescription,
              includeAssurance16: this.state.includeAssurance16,
              includeNominalBenefits: this.state.includeNominalBenefits,

              includeCrisis: this.state.includeCrisis,
              includeCategoricalEligibility: this.state.includeCategoricalEligibility,
              includeIncomeThreshold: this.state.includeIncomeThreshold,
              includeHousing: this.state.includeHousing,

              includeBenefitMatrix: this.state.includeBenefitMatrix,
              includeCriteriaForVarying: this.state.includeCriteriaForVarying,
              includeBenefitLevels: this.state.includeBenefitLevels,

              includeOutreach: this.state.includeOutreach,
              includePercentageWeatherization: this.state.includePercentageWeatherization,
              includeIntakeOrganizationType: this.state.includeIntakeOrganizationType,

              selectedIndexValOperator: this.state.selectedIndexValOperator,
              enteredIndexVal: this.state.enteredIndexVal,
              enteredIndexValUpperBound: this.state.enteredIndexValUpperBound,

              //NO LONGER USED FOR FILTERING
              crisisPeriod: this.state.CrisisPeriod,
              hasCategoricalEligibility: this.state.CategoricalEligibility,
              hasCoolingProgram: this.state.HasCoolingProgram,
              runsAssurance16: this.state.RunsAssurance16,
              incomeCutoff: this.state.IncomeThreshold,
              intake: this.state.OrgPerformingIntake,
              weatherizationPercent: this.state.PercentageForWeatherization,
              climateZone: this.state.ClimateZone,
              eaProgram: this.state.EnergyAssistProgram,
              fuelType: this.state.FuelTypes,
              itSystemType: this.state.TypeOfITSystem,
              programFundingLevel: this.state.ProgramFundingLevel,
              states: this.state.SelectedGranteeArray,
            };

            //call the grantee search portal api to get comparison
            const baseWorker: worker.baseWorker = new worker.baseWorker();
            searchPortalResults = await baseWorker.getGranteeSearchPortalData(searchParams);

            //get households served
            const pmWorker: utility.PerformanceDataWorker = new utility.PerformanceDataWorker();
            granteeHouseholdsServed = await pmWorker.getHouseholdsServedForGrantees(this.state.SelectedGranteeArray);

          }
          catch (err) {
            if (err.response.data) {
              errorMessage = err.response.data.message;
            }
            else {
              errorMessage = err.response.data;
            }
            
          }
        }

        newAppPage = errorMessage === '' ? newAppPage : this.state.CurrentAppPage;
        
        // React 18: Optimized state update with automatic batching
        // Single setState call for better performance
        this.setState({
          ErrorMessage: errorMessage,
          ShowSpinner: false,
          CurrentAppPage: newAppPage,
          ShowNextStepDisabled: newShowNextStepDisabled,
          SelectedIndexHistory: myHistoryObject,
          GranteePortalResults: searchPortalResults,
          GranteeHouseholdsServed: granteeHouseholdsServed,
          Regions: regions,
          SelectedGranteeArray: selectedGranteeArray
        });
        
        // React 18: Automatic batching ensures this runs after state update
        this.state.scrollToTop();
      }
    }.bind(inParentComponent),
    showPreviousStep: async function (): Promise<void> {
      if (this.state.CurrentAppPage > AppPagesEnum.IntroPage1) {
        // React 18: Immediate UI update for spinner
        this.setState({ ShowSpinner: true });
        
        let newAppPage = this.state.CurrentAppPage - 1;

        //if we are going to the select screen and haven't picked
        //and index type to show, disable next button
        let newShowNextStepDisabled = false;
        if (newAppPage == AppPagesEnum.SelectionScreen
          && this.state.SelectedIndexCode == utility.IndexCodeEnum.NotSet) {
          newShowNextStepDisabled = true;
        }

        // React 18: Optimized state update with automatic batching
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAppPage: newAppPage,
          ShowNextStepDisabled: newShowNextStepDisabled,
        });
        
        // React 18: Automatic batching ensures this runs after state update
        this.state.scrollToTop();
      }
    }.bind(inParentComponent),
    showComparison: async function (): Promise<void> {
      //set state object
      this.setState({
        ErrorMessage: '',
        ShowSpinner: false,
        CurrentAppPage: AppPagesEnum.BenefitTargetingComp4,
      });
      this.state.scrollToTop();
    }.bind(inParentComponent),
    displaySelectedIndexString: function (): string {
      if (this.state.SelectedIndexCode === utility.IndexCodeEnum.BurdenReductionIndex) {
        return "Burden Reduction";
      }
      else if (this.state.SelectedIndexCode === utility.IndexCodeEnum.TargetingIndex) {
        return "Benefit Targeting";
      }
      else {
        return "";
      }
    }.bind(inParentComponent),
    burdenReductionFilterHandler: function (inTarget: string, inValue: any): void {
      let granteesArray = Object.assign([], this.state.SelectedGranteeArray);
      let regionId = this.state.SelectedGranteeArray;
      if (inTarget == "SelectedGrantees") {
        granteesArray = [];
        //inValue is an HTML option collection
        for (var counter = 0; counter < inValue.length; counter++) {
          granteesArray.push(inValue[counter].value);
        };
      }
      else if (inTarget == "SelectedRegionId") {
        //get the states in the selected region
        granteesArray = this.state.Grantees
          .filter(g => g.regionId == inValue)
          .map(g => g.granteeId);
        regionId = inValue;
      }
      this.setState({
        ErrorMessage: '',
        ShowSpinner: false,
        SelectedRegionId: regionId,
        SelectedGranteeArray: granteesArray,
      });
    }.bind(inParentComponent),
    benTargetingComp4ClickHandler: function (inEvent: any): void {
      this.setState({
        ErrorMessage: '',
        ShowSpinner: false,
        selectedIndexValOperator: inEvent.target.value,
      });
    }.bind(inParentComponent),

    reviewOtherIndex: function (inEvent: any): void {
      let newAppPage: number = AppPagesEnum.BenefitTargeting1;
      let selectedIndexCode: string = this.state.SelectedIndexCode === utility.IndexCodeEnum.BurdenReductionIndex ?
        utility.IndexCodeEnum.TargetingIndex
        : utility.IndexCodeEnum.BurdenReductionIndex;
      let myHistoryObject: IndexHistory = Object.assign(new IndexHistory('', [], [], '', ''), this.state.SelectedIndexHistory);

      myHistoryObject.IndexCode = selectedIndexCode;

      this.setState({
        ErrorMessage: '',
        ShowSpinner: false,
        CurrentAppPage: newAppPage,
        SelectedIndexCode: selectedIndexCode,
        SelectedIndexHistory: myHistoryObject
      });
    }.bind(inParentComponent),

    benTargetingComp4InputHandler: function (inEvent: any): void {
      let indexVal: number = this.state.enteredIndexVal;
      let indexValUpperBound: number = this.state.enteredIndexValUpperBound;
      if (inEvent.target.name === "txtIndexVal") {
        indexVal = inEvent.target.value;
      }
      else {
        indexValUpperBound = inEvent.target.value;
      }
      //call component setstate to force re-render
      this.setState({
        ErrorMessage: '',
        ShowSpinner: false,
        enteredIndexVal: indexVal,
        enteredIndexValUpperBound: indexValUpperBound,
      });
    }.bind(inParentComponent),
    benTargetingComp4Clicked: function (targetName: string, inEvent: any): void {
      this.setState({
        [targetName]: inEvent.target.checked
      });
    }.bind(inParentComponent),
    //----------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------
    // Helper Methods 
    //----------------------------------------------------------------------------------------------
    backToStart: async function (): Promise<void> {
      this.setState({
        ErrorMessage: '',
        CurrentAppPage: AppPagesEnum.IntroPage1,
        ShowSpinner: false,
      });
    }.bind(inParentComponent),
    showError: function (errorMessage: string) {
      this.setState({
        ShowSpinner: false,
        ErrorMessage: errorMessage,
      });
      this.state.scrollToTop();
    }.bind(inParentComponent),
    setCurrentUserInfo: function (inUser: worker.IUserInfo): void {
      this.setState({
        ErrorMessage: '',
        UserInfo: inUser
        , SelectedGranteeId: inUser.granteeId
        , SelectedGranteeArray: [inUser.granteeId]
        , SelectedRegionId: inUser.regionId
      });
    }.bind(inParentComponent),
    showSpinner: function () {
      this.setState({
        ErrorMessage: '',
        ShowSpinner: true,
      });
    }.bind(inParentComponent),
    hideSpinner: function () {
      this.setState({
        ShowSpinner: false,
      });
    }.bind(inParentComponent),
    scrollToTop: function () {
      const yOffset = -200;
      const element = document.getElementById("app");
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    },
    isNullOrEmpty: function (inString: any): boolean {
      if (inString === '' || inString === null) {
        return true;
      }
      else {
        return false;
      }
    },
    getGranteeName: function (inGranteeId: number): string {
      let granteeName: string = "";
      const granteeArray = this.state.Grantees.filter(e => { return Number(e.granteeId) === Number(inGranteeId); });
      if (granteeArray.length > 0) {
        granteeName = granteeArray[0].granteeName;
      }
      return granteeName;
    }.bind(inParentComponent),
    getGranteeAbbreviation: function (inGranteeId: number): string {
      let granteeAbbreviation: string = "";
      const granteeArray = this.state.Grantees.filter(e => { return Number(e.granteeId) === Number(inGranteeId); });
      if (granteeArray.length > 0) {
        granteeAbbreviation = granteeArray[0].granteeAbbreviation;
      }
      return granteeAbbreviation;
    }.bind(inParentComponent),
    //----------------------------------------------------------------------------------------------
  };
} /* End createState(). */

